import React from 'react';

import {
  Routes,
  Route,
} from "react-router-dom";

import RouterPublic from './Routes/PublicRoutes'
import AdminRoutes from './Routes/AdminRoutes';
import CustomerRoutes from './Routes/CustomerRoutes';

/**
 * 
 * @export
 * @function Routes
 * @description Main router for app
 */

 export default function() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/customer/*" element={<CustomerRoutes />} />
      <Route path="/*" element={<RouterPublic />} />
    </Routes>
  )
}